import http from './http';
import { listResource } from './listResource';

export async function listUsers(options = {}) {
  return listResource('/admin/user/list', options);
}

/**
 * Obtiene un usuario por su ID.
 */
export async function getUserById(id) {
  const res = await http.get(`/admin/user/${id}`);
  return res.data?.data ?? res.data;
}
/**
 * Crea un nuevo usuario.
 */
export async function createUser(userData) {
  const res = await http.post('/admin/user/create', userData);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un usuario.
 */
export async function updateUser(id, userData) {
  const res = await http.put(`/admin/user/edit/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza perfil de un usuario.
 */
export async function updateUserProfile(id, userData) {
  const res = await http.put(`/admin/user/profile/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Cambia la contraseña de un usuario.
 */
export async function changeUserPassword(userId, newPassword) {
  if (!userId) {
    throw new Error('El ID del usuario es requerido');
  }
  
  if (!newPassword) {
    throw new Error('La contraseña es requerida');
  }

  const res = await http.post(`/admin/user/${userId}/password`, { newPassword });
  return res.data?.data ?? res.data;
}

/**
 * Sube un archivo.
 */
export async function uploadAvatar(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/admin/user/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

/**
 * Activar/Desactivar Usuario
 */
export const updateUserStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/admin/user/${id}/status`, { isActive: isActive });

/**
 * Eliminar Usuario
 */
export const deleteUser = (id) => http.delete(`/admin/user/delete/${id}`);

/**
 * Reenviar invitación de activación
 */
export const resendActivation = (id) => http.post(`/admin/user/${id}/resend-activation`);

export async function sendTemporaryPassword(data) {
  const res = await http.post('/auth/send-temporal-password-admin', data);
  return res.data?.data ?? res.data;
}

export async function resetPassword(data) {
  const res = await http.post('/admin/user/reset-password-admin', data);
  return res.data?.data ?? res.data;
}